/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  McpNetworkTrafficPoint,
  McpNetworkTrafficPoint$inboundSchema,
} from "./mcpnetworktrafficpoint.js";

/**
 * Observed resolved inbound MCP requests, not a guarantee of every client. No observations does not prove a route is unused.
 */
export type GetMcpNetworkTrafficResult = {
  /**
   * Start of the window
   */
  from: Date;
  /**
   * Most recent observed private request in the window
   */
  lastPrivateAt?: Date | undefined;
  /**
   * Most recent observed public request in the window
   */
  lastPublicAt?: Date | undefined;
  /**
   * Hourly request counts
   */
  points: Array<McpNetworkTrafficPoint>;
  /**
   * End of the window
   */
  to: Date;
};

/** @internal */
export const GetMcpNetworkTrafficResult$inboundSchema: z.ZodMiniType<
  GetMcpNetworkTrafficResult,
  unknown
> = z.pipe(
  z.object({
    from: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    last_private_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    last_public_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    points: z.array(McpNetworkTrafficPoint$inboundSchema),
    to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  }),
  z.transform((v) => {
    return remap$(v, {
      "last_private_at": "lastPrivateAt",
      "last_public_at": "lastPublicAt",
    });
  }),
);

export function getMcpNetworkTrafficResultFromJSON(
  jsonString: string,
): SafeParseResult<GetMcpNetworkTrafficResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMcpNetworkTrafficResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMcpNetworkTrafficResult' from JSON`,
  );
}
